module.exports = __webpack_public_path__ + "static/img/img2.cd003df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/modeling/expression/img2.png
// module id = RZ9l
// module chunks = 7